import styled from 'styled-components'

import { NotificationWidgetWalletsBody } from './notification-widget-wallets-body'
import { NotificationWidgetWalletsColumn } from './notification-widget-wallets-column'
import { NotificationWidgetWalletsRow } from './notification-widget-wallets-row'

import type { NotificationWidgetVariant } from '../../model'

type Props = {
  variant: NotificationWidgetVariant
}

export const NotificationWidgetWallets: React.FC<Props> = ({ variant }) => {
  const Header =
    variant === 'row'
      ? NotificationWidgetWalletsRow
      : NotificationWidgetWalletsColumn

  return (
    <Root data-variant={variant}>
      <Header />
      <NotificationWidgetWalletsBody />
    </Root>
  )
}

const Root = styled.div`
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
  padding: 3px;

  display: grid;

  &[data-variant='row'] {
    grid-template-columns: 1fr 1fr;
  }
  &[data-variant='square'] {
    grid-template-rows: auto 1fr;
  }
`
